// @ts-check
import { route } from './author.js';
// Alternating height and a safe sentinel lane replace the former short relay.
export const RELAY = route(1, 2, 'Packet Relay', 'Stomp security units. Kick a dormant sentinel core through the lower lane.', 148)
  .node(9).platform(15, 2, 5, 0.5).bot(17, 2.5).bot(24, 0, true)
  .platform(30, 3, 3, 1, 'cache').bot(35).bot(39).node(43, 3, 'bit')
  .checkpoint(48, 'Relay junction').gap(54, 3).platform(60, 1, 4, 0.5).platform(67, 3, 4, 0.5)
  .bot(69, 3.5).node(74).platform(81, 0, 2, 2, 'conduit').gap(88, 3)
  .checkpoint(96, 'Upper relay').platform(103, 2, 6, 0.5).bot(105, 2.5, true)
  .node(111, 4, 'overclock').bot(117).bot(121).platform(125, 2, 3, 1, 'cache')
  .stairs(132, 4).stairs(136, 4, true).build();
export const UPPER_BUS = route(1, 3, 'The Upper Bus', 'Double jump to the upper bus. Ground pound cracked caches to return.', 154)
  .node(9).platform(16, 1, 4, 0.5).platform(23, 3, 4, 0.5).platform(31, 5, 5, 0.5)
  .node(34, 7).bot(39).gap(43, 3).checkpoint(49, 'Bus anchor')
  .platform(55, 2, 4, 0.5).platform(63, 4, 5, 0.5).platform(73, 6, 7, 0.5)
  .platform(80, 4, 3, 1, 'cache').node(77, 8, 'overclock').bot(67, 4.5)
  .platform(86, 2, 4, 0.5).gap(93, 3).checkpoint(101, 'Return bus')
  .node(106).platform(114, 3, 5, 1, 'cache').bot(116, 4)
  .platform(124, 1, 3, 0.5).platform(130, 3, 3, 0.5).gap(136, 3).bot(143).build();
export const BOOT_GATE = route(1, 4, 'Boot Gate', 'Strike signal nodes, then outwit the Gatekeeper at the socket.', 102)
  .node(9, 3, 'upgrade', 'boot').device('phase', 16, 2, 4, 0.5, 4, { group: 'boot', alternate: true })
  .gap(22, 3).node(29, 3, 'bit', 'boot').platform(36, 0, 2, 2, 'conduit').bot(42, 0, true)
  .checkpoint(48, 'Boot control').node(53, 3, 'overclock').bot(58).bot(62)
  .platform(65, 2, 4, 0.5).boss('gatekeeper', 'Gatekeeper').build();
